function FilterOption({ label, checked, onClick }) {
  return (
    <button
      className={`border-0 text-sm hover:text-k-orange transition ${checked ? 'text-gray-500 font-medium' : 'text-gray-400'}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

export default function NotificationPopoverFilter({
  unreadCount,
  unreadOnly,
  setUnreadOnly,
}) {
  return (
    <div className="flex justify-center space-x-6">
      <FilterOption
        label={`Unread (${unreadCount})`}
        checked={unreadOnly}
        onClick={() => setUnreadOnly(true)}
      />

      <FilterOption
        label="All"
        checked={!unreadOnly}
        onClick={() => setUnreadOnly(false)}
      />
    </div>
  );
}
